import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';
import ArticleCard from '../components/ArticleCard';
import { FaBookOpen } from 'react-icons/fa'; // 1. Import a suitable icon
import Pagination from '../components/Pagination';
import { AuthContext } from '../../context/AuthContext';

// A helper function to parse query params
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Blog = () => {
  const { loadingHandle } = useContext(AuthContext);
  const [blogs, setBlogs] = useState([]);
  const [title, setTitle] = useState('All Articles');
  
  const location = useLocation(); 
  const query = useQuery();

  // PAGINATION
   const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(20);
    // Pagination Logic
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = blogs.slice(indexOfFirstPost, indexOfLastPost);
  
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const categoryId = query.get('category');
        const searchQuery = query.get('search');

        const { data } = await axiosInstance.get(`/blogs`, {
          params: {
            category: categoryId,
            search: searchQuery
          }
        });
        
        setBlogs(data);

        // Update the page title based on the filter
        if (searchQuery) {
          setTitle(`Search Results for: "${searchQuery}"`);
        } else if (categoryId && data.length > 0) {
          setTitle(`${data[0].category_name}`);
        } else if (categoryId && data.length === 0) {
            setTitle('No articles found in this category');
        } else {
          setTitle('All Articles');
        }

      } catch (error) {
        console.error('Error fetching blogs', error);
      }
    };
    loadingHandle(true);
    fetchBlogs();
    loadingHandle(false)
  }, [location.search]);

  return (
    <div className="container mx-auto p-6">
      {/* --- 2. UPDATED TITLE SECTION --- */}
      <div className="flex items-center justify-center gap-4 mb-8">
        <FaBookOpen className="text-4xl md:text-5xl text-indigo-600" />
        <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-800">
          {title}
        </h1>
      </div>

      {blogs.length > 0 ? (
        <div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {currentPosts && currentPosts.map((blog) => (
            <ArticleCard key={blog.id} blog={blog} />
          ))}
        </div>
         <Pagination
                postsPerPage={postsPerPage}
                totalPosts={blogs.length}
                paginate={paginate}
                currentPage={currentPage}
            />
        </div>
      ) : (
        <p className="text-center text-gray-500 mt-12">No articles found.</p>
      )}
    </div>
  );
};

export default Blog;